import React, {Component, Suspense} from 'react';
import NewEntityProtectoraDetail from "./NewEntityProtectoraDetail";
import FAQs_component from "../../../Shared/components/components/FAQs/FAQs_component";
import AnimalShelter_Schema_org from "./schemaOrg/AnimalShelter_Schema_org";
import EntityList from "../../../EntityList/components/EntityList";
import GoogleMapsEmbed from "../../../EntityList/components/Map/GoogleMapsEmbed";
import {ADS_TYPES, AdsManagerContainer} from "../../../Ads/components/AdsManagerContainer";

class EntityProtectoraDetailContainer extends Component {
    
    constructor(props) {
        super(props);
        
        this.onClickCardRecomendation = this.onClickCardRecomendation.bind(this);
    }
    
    showLoader() {
    }
    
    buildFAQsList() {
        let nombre = this.props.infoEntity.nombre
        let municipio = (this.props.infoEntity?.direccion?.municipio) ? (this.props.infoEntity.direccion.municipio) : (this.props.infoEntity?.direccion?.region) ? (this.props.infoEntity.direccion.region) : this.props.infoEntity?.direccion?.provincia || "en España"
        const arrayFaqs = []
        const faqsFlags = this.props.infoEntity?.faqs
        arrayFaqs.push({
            question: "¿Cómo llegar a <strong>" + nombre + "</strong>?",
            answer: "<strong>" + nombre + "</strong> está en la<strong> zona de " + municipio + "</strong>, por seguridad no compartimos la ubicación exacta, "+
                "pero si tienes interés en adoptar un animal con ellos, hacerles una donación o ayudarles puedes ponerte en contacto con ellos y te informarán sin ningún problema"
        });
        arrayFaqs.push({
            question: "¿Qué debo hacer para adoptar un animal en <strong>" + nombre + "</strong>?",
            answer: "Para adoptar un animal en <strong>" + nombre + "</strong> tienes que ponerte en contacto con ellos, te dirán que animales tienen en adopción"+
                " y cómo puedes ir a verlos. Seguramente deberás rellenar un formulario o hacer una pequeña entrevista previa con tus datos, preguntas sobre dónde vivirá el animal, "+
                "sobre su futura familia y cómo se lleva con los animales y cómo será el trato con el animal. Normalmente se recomienda hacer varias visitas previas a la adopción "+
                "para que os podáis conocer mejor el animal y tu."
        });
        if (!faqsFlags || faqsFlags?.perros || faqsFlags?.perros === undefined) {
            arrayFaqs.push({
                question: "¿Cuánto cuesta adoptar un perro en <strong>" + nombre + "</strong>?",
                answer: "El coste medio de adoptar un perro en las protectoras de la zona de " + municipio + " oscila entre los 0€ y los 180€ para cachorros " +
                    "menores de 6 meses y para los perros adultos entre 0€ y 100€. Perros mayores de más de 10 años a menudo es a la voluntad. Ante todo debes preguntar a <strong>" + nombre + "</strong> para que te informen mejor. Todos los perros se suelen "+
                    "entregan con sus vacunas al día, esterilizados si son adultos, desparasitados interna y externamente y con el microchip. "+
                    "<br>Este coste cubre los gastos de veterinarios, incluyendo una revisión previa para asegurarse de que el perro está sano antes de la adopción y "+
                    "algunos gastos de haberlos estado cuidando y una ayuda para seguir con su labor."
            });
        }
        if (!faqsFlags || faqsFlags?.gatos || faqsFlags?.gatos === undefined) {
            arrayFaqs.push({
                question: "¿Cuánto cuesta adoptar un gato en <strong>" + nombre + "</strong>?",
                answer: "El coste medio de adoptar un gato en las protectoras y asociaciones de la zona de " + municipio + " oscila entre 0€ y los 50€ si es cachorro y los 0€ y 130€ si "+
                    "es un gato adulto. Ante todo debes preguntar a <strong>" + nombre + "</strong> para que te informen mejor. Este coste suele incluir una revisión veterinaria completa para "+
                    "asegurarse de que el gato está sano antes de la adopción y algunos gastos de haberlos estado cuidando y una ayuda para seguir con su labor, tratamientos previos si fueron "+
                    "necesarios, desparasitación interna y externa, y normalmente tests de inmunodeficiencia y leucemia inicial y vacunas trivalentes y leucemia, chip, esterilización."
            });
        }
        arrayFaqs.push({
            question: "¿Qué servicios ofrece <strong>" + nombre + "</strong>?",
            answer: "<strong>" + nombre + "</strong> ofrece servicios como adopciones <strong> cerca de " + municipio + "</strong>, apadrinamientos, "+
                "información especializada de cara a la adopción de animales o recogida de animales abandonados en <strong>" + municipio + "</strong> y los municipios cercanos."+
                " Ponte en contacto con ellos para que te puedan informar mejor 😊"
        });
        arrayFaqs.push({
            question: "¿Cómo puedo ayudar a <strong>" + nombre + "</strong>?",
            answer: "Hay varias formas en las que puedes ayudar a <strong>" + nombre + "</strong>: " + "<ul>" + "<li>Dona dinero o hazte socio de <strong>" + nombre + "</strong> "+
                "para pagar los gastos veterinarios, la comida y los suministros para los animales</li>" + "<li>Adopta un animal en <strong>" + nombre + "</strong></li>" +
                "<li>Ayuda a difundir compartiendo en redes sociales o cuéntale a tus amigos que vivan <strong> cerca de " + municipio + "</strong> sobre ellos. "+
                "Esto puede ayudar a dar a conocer su trabajo y a atraer más donaciones y adopciones</li>" + "<li>Y por último ofreceles tu tiempo y habilidades, "+
                "siempre se necesitan voluntarios para ayudar con los animales, la limpieza y otros trabajos y ¡seguro que en <strong>" + nombre + "</strong> están "+
                "encantados de recibirte!</li>" + "</ul>"
        });
        arrayFaqs.push({
            question: "¿Cómo puedo ser voluntario de <strong>" + nombre + "</strong>?",
            answer: "Para ser voluntario en <strong>" + nombre + "</strong>, sigue estos pasos:" + "<ol>" + "<li>Ponte en contacto con <strong>" + nombre + "</strong>: "+
                "ponte en contacto con ellos para solicitar más información. Pregúntales cuáles son sus requisitos y cómo puedes hacer para ser voluntario.</li>" +
                "<li>Los más seguro es que tengas que hacer una pequeña entrevista para que te conozcan mejor</li>" +
                "<li>A veces cuando hay mucha demanda en una protectora o asociación se ofrecen reuniones o entrenamientos para sus voluntarios nuevos. Si no, te informarán personalmente sobre "+
                "como puedes ayudarles y que deberás hacer</li>" +
                "<li>Una vez seas aceptado solo tendrás que dedicar parte de tu tiempo en ayudar a los animales o al mantenimiento de las instalaciones. "+
                "Con unas horas a la semana estarás aportando una gran ayuda a <strong>" + nombre + "</strong> y a salvar vidas de animales</li>" + "</ol>"
        });
        arrayFaqs.push({
            question: "¿Qué es ser una casa de acogida para <strong>" + nombre + "</strong> y cómo puedo convertirme en una casa de acogida para <strong>" + nombre + "</strong>?",
            answer: "Ser casa de acogida es ofrecer tu casa para acoger durante un tiempo a un animal que necesita hogar mientras encuentra un hogar y una femilia definitovos." +
                "Para ser casa de acogida primero, ponte en contacto con <strong>" + nombre + "</strong>. Si tienen un programa de casas de acogida <strong> cerca de " + municipio + "</strong>, "+
                "sigue sus instrucciones y proceso el de solicitud. Asegúrate de tener el espacio y los recursos necesarios para cuidar adecuadamente al animal, y sigue las pautas "+
                "de la protectora para el cuidado del animal. Recuerda que ser una casa de acogida es una gran responsabilidad, así que asegúrate de estar dispuesto a comprometerte "+
                "antes de hacerlo y una gran alegría para el alma, ya que podrás ayudar a un animal sin hogar y él te dará todo el amor que tienen."
        });
        arrayFaqs.push({
            question: "¿Cuáles son las actividades de <strong>" + nombre + "</strong>?",
            answer: "En <strong>" + nombre + "</strong> hacen una labor muy importante para la sociedad, luchan por la causa animal y por concienciar a la gente sobre el abandono "+
                "y el maltrato a los animales <strong> en la zana de " + municipio + "</strong>. En <strong>" + nombre + "</strong> todos los animales son esterilizados y atendidos por "+
                "veterinarios antes de ponerlos en adopción (si no puede ser te informarán cómo hacerlo y dónde). "+
                ((!faqsFlags || faqsFlags?.gatos || faqsFlags?.gatos === undefined)?"Además, con los gatos callejores utilizan el método CER o CES para controlar la población de gatos "+
            "y colonias ferales y crear colonias controladas cuando es necesario":"")+". "+((!faqsFlags || faqsFlags?.perros || faqsFlags?.perros === undefined)?"También recuperan y "+
            "ayudan a educar a sus perros con el objetivo de encontrarles hogares felices para adoptar <strong> cerca de " + municipio + "</strong>":"")
    });
        arrayFaqs.push({
            question: "¿Cómo se financia la labor de <strong>" + nombre + "</strong>?",
            answer: "<strong>" + nombre + "</strong> se financia gracias a:" + "<ul>" +
                "<li>Las aportaciones de sus socios y voluntarios. Los socios realizan aportaciones mensuales, también gracias a las donaciones de material.</li>" +
                "<li>Otra opción es con los apadrinamientos de animales gracias a esto ayudas a pagar su manutención hasta que encuentre un hogar definitivo</li>" +
                "<li>Con la gente ayuda con su casa en forma de casa de acogida <strong> cerca de " + municipio + "</strong></li>" +
                "<li>También con el tiempo libre de sus voluntarios, ayudando con sus peludos, jugando con ellos, paseándolos, transportando comida o haciendo traslados. </li>" +
                "<li>Otra opción es con el Teaming de <strong>" + nombre + "</strong> y aportar una pequeña cantidad todos los meses. </li>" + "</ul>"
        });
        arrayFaqs.push({
            question: "¿<strong>" + nombre + "</strong> acepta donativos?",
            answer: "¡Por supuesto! <strong>" + nombre + "</strong> acepta donativos, estarán encantados de que les hagas una donación en forma de dinero, comida para sus peludos o "+
                "artículos relacionados con los animales como correas, collares, mantas para el invierno... Contáctales y ofréceles tu donativo ❤️."
        });
        arrayFaqs.push({
            question: "¿Para qué se utilizan las donaciones en <strong>" + nombre + "</strong>?",
            answer: "Las donaciones que se hacen a <strong>" + nombre + "</strong> se utilizan principalmente para cubrir los gastos veterinarios como exámenes, medicamentos y cirugías, "+
                "la comida y los suministros para los animales como jaulas, camas, juguetes y más artículos para el cuidado de animales. Y también se utilizan para pagar los gastos operativos "+
                "de <strong>" + nombre + "</strong>, etc. También pueden utilizarse para financiar programas de esterilización y adopción, así como campañas de concientización "+
                "y otras actividades de sensibilización."
        });
        arrayFaqs.push({
            question: "¿Cómo puedo apadrinar a un animal en <strong>" + nombre + "</strong>?",
            answer: "Apadrinar un animal es una forma de ayudar a cubrir sus gastos de manutención y cuidados médicos mientras está en <strong>" + nombre + "</strong>. "+
                "Para apadrinar un animal, sigue estos pasos:" + "<ol>" +
                "<li>Contacta con la protectora y pregunta sobre su programa de apadrinamiento. Te informarán sobre qué animales están disponibles para ser apadrinados y cuáles son sus necesidades. </li>" +
                "<li>Luego elige el animal que quieres apadrinar.</li>" +
                "<li>Realiza una aportación mensual: aporta una cantidad mensual para cubrir los gastos del animal, suelen ser unos 15€ al mes pero puedes aportar más sin problema.</li>" +
                "<li>La protectora te proporcionará información regular sobre el estado y el progreso del animal que estás apadrinando. También puedes visitar al animal de vez en cuando "+
                "para estar con él y darle tu cariño</li>" + "</ol>"
        });
        
        return arrayFaqs
    }
    
    onClickCardRecomendation(idClick) {
        //console.log("EntityProtectoraDetailContainer::onCLickCard()");
        this.props.onClickCardRecomendation(idClick)
    }
    
    render() {
        let showAnimalList, showSimilarEntitiesRecomendation, showNearEntitiesRecomendation, showMapEmbed
        
        
        if (this.props.animalsProtectora && this.props.animalsProtectora.animals && this.props.animalsProtectora.animals.length > 0) {
            showAnimalList = true
        }
        const listFAQs = this.buildFAQsList()
        
        if (this.props.recomendations?.entities?.similar?.length > 0) {
            showSimilarEntitiesRecomendation = true
        }
        
        if (this.props.recomendations?.entities?.near?.length > 0) {
            showNearEntitiesRecomendation = true
        }
        
        if (this.props.infoEntity?.direccion) {
            showMapEmbed = true
        }
        
        return (<div id="" className="">
            
            <div>
                {this.props.infoEntity && <NewEntityProtectoraDetail
                    infoEntity={this.props.infoEntity}
                    access={this.props.access}
                />}
            </div>
            {showMapEmbed && <div>
                <hr/>
                <div className="section">
                    <h2 className="card-title">Cómo llegar a {this.props.infoEntity.nombre}</h2>
                    <p><strong>{this.props.infoEntity.nombre}</strong> está en la<strong> zona
                        de {this.props.infoEntity.direccion.municipio}</strong>, por seguridad no
                        compartimos la ubicación exacta, pero si tienes interés en adoptar un animal con ellos,
                        hacerles una donación o ayudarles puedes ponerte en contacto con ellos y te informarán
                        encantados 😊</p>
                    <div>
                        {/*<GoogleMapsEmbed*/}
                        {/*    center={{*/}
                        {/*        lat: this.props.infoEntity.direccion.location.coordinates[1],*/}
                        {/*        lng: this.props.infoEntity.direccion.location.coordinates[0]*/}
                        {/*    }}*/}
                        {/*/>*/}
                        {!this.props.userLocation && <GoogleMapsEmbed
                            location={{
                                municipio: this.props.infoEntity?.direccion.municipio,
                                provincia: this.props.infoEntity?.direccion.provincia,
                                pais: this.props.infoEntity?.direccion.pais,
                            }}
                        />}
                        
                        {this.props.userLocation && <GoogleMapsEmbed
                            origin={{
                                type: "coordinates",
                                lat: this.props.userLocation.lat,
                                lng: this.props.userLocation.lng,
                            }}
                            destination={{
                                type: "location",
                                municipio: this.props.infoEntity?.direccion.municipio,
                                provincia: this.props.infoEntity?.direccion.provincia,
                                pais: this.props.infoEntity?.direccion.pais
                            }}
                        />}
                        {/*<GoogleMapsEmbed*/}
                        {/*    center={{*/}
                        {/*        lat: this.props.infoEntity.direccion.location.coordinates[1],*/}
                        {/*        lng: this.props.infoEntity.direccion.location.coordinates[0]*/}
                        {/*    }}*/}
                        {/*/>*/}
                        {/*<GoogleMapsEmbed*/}
                        {/*    location={{*/}
                        {/*        municipio: this.props.infoEntity?.direccion.municipio,*/}
                        {/*        provincia: this.props.infoEntity?.direccion.provincia,*/}
                        {/*        pais: this.props.infoEntity?.direccion.pais,*/}
                        {/*    }}*/}
                        {/*/>*/}
                        {/*{this.props.userLocation &&*/}
                        {/*<GoogleMapsEmbed*/}
                        {/*    origin={{*/}
                        {/*        type: "coordinates",*/}
                        {/*        lat: this.props.userLocation.lat,*/}
                        {/*        lng: this.props.userLocation.lng,*/}
                        {/*    }}*/}
                        {/*    destination={{*/}
                        {/*        type: "location",*/}
                        {/*        municipio: this.props.infoEntity?.direccion.municipio,*/}
                        {/*        provincia: this.props.infoEntity?.direccion.provincia,*/}
                        {/*        pais: this.props.infoEntity?.direccion.pais*/}
                        {/*    }}*/}
                        {/*/>*/}
                        {/*}*/}
                    
                    </div>
                </div>
            </div>
            
            }
            <AdsManagerContainer type={ADS_TYPES.MEGABANNER}/>
            {showSimilarEntitiesRecomendation && <div>
                <hr/>
                <div className="section">
                    <div className="cardInfoTitle">
                        <h2 className="card-subtitle">Más protectora de animales <strong> cerca
                            de {this.props.infoEntity.direccion?.municipio}</strong></h2>
                    </div>
                    
                    <div id="animals-list-container" className="">
                        <EntityList
                            entities={{list: this.props.recomendations.entities.similar}}
                            config={this.props.config}
                            onClickCard={this.onClickCardRecomendation}
                            isRecomendationCards
                        />
                        {/*    <AnimalList*/}
                        {/*        list={this.props.animalsProtectora.animals}*/}
                        {/*        isReady={true}*/}
                        {/*        totalRecord={this.props.animalsProtectora.totalRecord}*/}
                        {/*        pag={this.props.animalsProtectora.pag}*/}
                        {/*        elementsPerRow={this.state.elementsPerRow}*/}
                        {/*        elementsPerPage={this.state.elementsPerPage}*/}
                        {/*        animalsControl={this.props.animalsControl}*/}
                        {/*        animalsControlDetail={this.props.animalsControlDetail}*/}
                        {/*        isAdminAnimals={false}*/}
                        {/*        access={this.props.access}*/}
                        {/*    />*/}
                    </div>
                </div>
            </div>
            
            }
            
            {showNearEntitiesRecomendation &&
                
                <div>
                    <hr/>
                    <div className="section">
                        <div className="cardInfoTitle">
                            <h2 className="card-subtitle">Otras entidades pet frienly <strong> cerca
                                de {this.props.infoEntity.direccion?.municipio}</strong></h2>
                        
                        
                        </div>
                        {/*<div id="animals-list-container" className="">*/}
                        {/*    <AnimalList*/}
                        {/*        list={this.props.recomendations.animals}*/}
                        {/*        isReady={true}*/}
                        {/*        totalRecord={this.props.recomendations.animals.length}*/}
                        {/*        pag={0}*/}
                        {/*        elementsPerRow={this.state.elementsPerRow}*/}
                        {/*        elementsPerPage={this.state.elementsPerPage}*/}
                        {/*        animalsControl={this.props.animalsControl}*/}
                        {/*        animalsControlDetail={this.props.animalsControlDetail}*/}
                        {/*        isAdminAnimals={false}*/}
                        {/*        access={this.props.access}*/}
                        {/*    />*/}
                        {/*</div>*/}
                    </div>
                </div>
                
            }
            
            {this.props.infoEntity && <AnimalShelter_Schema_org
                infoEntity={this.props.infoEntity}
                HOST={process.env.HOST_ADOPTA}
            />}
            {/*<FAQs_component*/}
            {/*    name={this.props.infoEntity.nombre}*/}
            {/*    listQuestions={listFAQs}*/}
            {/*/>*/}
            <AdsManagerContainer type={ADS_TYPES.BILLBOARD}/>

            <FAQs_component
                name={this.props.infoEntity.nombre}
                listQuestions={listFAQs}
            />
            <AdsManagerContainer type={ADS_TYPES.MEGABANNER}/>

        </div>);
    }
    
    componentWillMount() {
    
    }
    
    componentDidMount() {
    }
    
    componentDidUpdate() {
        // console.log("EntityProtectoraDetailContainer::componentDidUpdate()");
        // if (this.props.waitBlock.showWaitBlock) {
        //     $('#modal-container').removeClass('out').addClass("one");
        //     $('body').addClass('modal-active');
        // } else {
        //     $('body').removeClass('modal-active');
        // }
    }
    
    
}


//El primer parametro es el mapeo de las props y el segundo las acciones- luego se le coloca que componente se ejecuta
export default EntityProtectoraDetailContainer
